import React from 'react';
import styles from './topbar.module.scss';
import Searchbox from '../searchbox';
import useTranslation from 'next-translate/useTranslation';
import AccountTrigger from '../accountTrigger';
import ShoppingListTrigger from '../shoppingListTrigger';

export default function Topbar(): JSX.Element {
  const { t } = useTranslation('application');
  return (
    <div className={styles.header}>
      <Searchbox />
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div className={styles.links}>
            <a href="https://www.flippappinions.com/c/a/6kiwEIx1Ce287lz8RyHYr8" target="blank">
              <button className={styles.settings}>
                <img
                  src="https://f.wishabi.net/creative/Distribution/images/icons/feedback-default5.svg"
                  height="26px"
                  alt=""
                />
                <span>{t('give_feedback')}</span>
              </button>
            </a>
          </div>
          <div className={styles.links}>
            <button className={styles.settings}>
              <img src="https://f.wishabi.net/creative/Distribution/images/icons/info_1.png" height="20px" alt="" />
              <span>{t('about_flipp')}</span>
            </button>
          </div>
        </div>
        <AccountTrigger />
        <ShoppingListTrigger />
      </div>
    </div>
  );
}
